export default "__VITE_ASSET__C5164eBV__"